(function () {
  'use strict';
  function mount(root) {
    if (root.getAttribute('data-layout-ready') === '1') return;
    root.setAttribute('data-layout-ready', '1');
    var controls = document.querySelector('[data-chamber-controls]');
    if (!controls) return;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var behavior = reduce ? 'auto' : 'smooth';
    var cue = controls.querySelector('[data-fit-cue]');
    var setButtons = Array.prototype.slice.call(controls.querySelectorAll('[data-fit-set]'));

    function centerPan() {
      if (root.getAttribute('data-fit') !== 'closer') return;
      root.scrollLeft = Math.max(0, (root.scrollWidth - root.clientWidth) / 2);
    }
    function setFit(mode) {
      root.setAttribute('data-fit', mode);
      controls.setAttribute('data-fit', mode);
      setButtons.forEach(function (b) { b.setAttribute('aria-pressed', b.getAttribute('data-fit-set') === mode ? 'true' : 'false'); });
      if (cue) cue.textContent = mode === 'closer' ? 'Swipe sideways to look around. Tap a coffee to explore.' : 'All four coffees are in view. Tap one to explore.';
      root.scrollLeft = 0;
      if (mode === 'closer') window.setTimeout(centerPan, 30);
    }
    setButtons.forEach(function (b) { b.addEventListener('click', function () { setFit(b.getAttribute('data-fit-set')); }); });

    Array.prototype.slice.call(controls.querySelectorAll('[data-card-for]')).forEach(function (card) {
      card.addEventListener('click', function () {
        var hot = root.querySelector('.scc-chamber__hot[data-guardian="' + card.getAttribute('data-card-for') + '"]');
        if (hot) hot.click();
      });
    });

    if ('MutationObserver' in window) {
      new MutationObserver(function () {
        var scene = root.getAttribute('data-scene');
        controls.setAttribute('data-scene', scene);
        if (scene === 'guardian') {
          var panel = root.querySelector('[data-guardian-panel]:not([hidden])');
          if (panel) window.setTimeout(function () { panel.scrollIntoView({ behavior: behavior, block: 'nearest' }); }, 60);
        } else {
          window.setTimeout(centerPan, 30);
          root.scrollIntoView({ behavior: behavior, block: 'nearest' });
        }
      }).observe(root, { attributes: true, attributeFilter: ['data-scene'] });
    }
    var lastW = window.innerWidth;
    window.addEventListener('resize', function () { if (window.innerWidth !== lastW) { lastW = window.innerWidth; centerPan(); } });
  }
  function init() {
    Array.prototype.slice.call(document.querySelectorAll('[data-room="guardian-chamber"]')).forEach(mount);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
